angular.module('client-feature')
    .component('clientFeaturePicker', {
        require: {
            ngModelCtrl: 'ngModel'
        },
        bindings: {
            required: "<?",
            modelType: "<?",
            filterField: "<?",
            onChange: "&"
        },
        templateUrl: "app/client-feature/picker/picker.html",
        controller: function(ClientFeature) {
            const ctrl = this;

            ctrl.$onInit = () => {
                ctrl.modelType = ctrl.modelType || "object";
                ctrl.required = ctrl.required || false;
                ctrl.filterField = ctrl.filterField || false;

                ctrl.loadItems()

                ctrl.ngModelCtrl.$render = () => ctrl.selected = ctrl.ngModelCtrl.$viewValue;
                ctrl.ngModelCtrl.$formatters.push(modelValue => modelValue);
                ctrl.ngModelCtrl.$parsers.push(viewValue => ctrl.modelType === "id" ? viewValue.id : viewValue);
            };

            ctrl.onSelectionChanged = ($item, $model) => {
                ctrl.ngModelCtrl.$setViewValue($item);
                ctrl.ngModelCtrl.$validate();
                ctrl.ngModelCtrl.$render();
                if (angular.isFunction(ctrl.onChange())) {
                    ctrl.onChange()($item);
                }
            };
            ctrl.loadItems = () => ClientFeature.autocomplete().$promise.then(items => ctrl.items = items)
        }
    })
